import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <img src="https://sharpautorepair.com/sharp_auto_repair_logo.svg" alt="Sharp Deal Auto Repair Logo" className="w-64 h-12" />
          </div>

          <nav className={`md:flex ${isMobileMenuOpen ? 'block' : 'hidden'} md:space-x-8 absolute md:static top-16 left-0 w-full md:w-auto bg-white md:bg-transparent p-4 md:p-0 shadow-md md:shadow-none z-40`}>
            <a href="#services" className="block md:inline-block text-gray-600 hover:text-primary font-medium transition-colors py-2 md:py-0">Services</a>
            <a href="#reviews" className="block md:inline-block text-gray-600 hover:text-primary font-medium transition-colors py-2 md:py-0">Reviews</a>
            <a href="#contact" className="block md:inline-block text-gray-600 hover:text-primary font-medium transition-colors py-2 md:py-0">Contact</a>
          </nav>

          <div className="flex items-center space-x-4">
            <a
              href="tel:3058210101"
              className="text-primary font-medium hover:text-secondary transition-colors hidden md:block"
            >
              Call Now
            </a>
            <div className="md:hidden">
              <button onClick={toggleMobileMenu} className="text-gray-600 hover:text-gray-900">
                <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} className="text-xl" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;